/**
 * @param {Object} jobData
 * @constructor
 */
export function ViewedJob(jobData = {}) {
    const salaryAmount = jobData['salary'] || '';
    const salaryType = jobData['salaryType'] || '';
    const salary = (salaryAmount + ' ' + salaryType).trim();

    this.addTime = Date.now();
    this.companyName = jobData['companyName'];
    this.features = jobData['features'] || [];
    this.isFromJobPanel = jobData['isFromJobPanel'];
    this.jobType = jobData['jobType'];
    //locationsは配列。locationsが空の時はlocationを配列にして取得
    this.locations = jobData['locations'] ? jobData['locations'] : [jobData['location']];
    this.salary = salary;
    this.title = jobData['title'];
    this.uniqueId = jobData['uniqueId'];
    this.stationName = jobData['stationName'];
    this.trainList = jobData['trainList'];
}
